







































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue'),
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class MedicineInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload

  get medicineCustodianOptions() {
    return [
      { label: '本人', value: 1 },
      { label: '家族', value: 2 },
      { label: 'ヘルパー', value: 3 }
    ]
  }

  get medicineReqGenelicOptions() {
    return [
      { label: 'する', value: 1 },
      { label: 'しない', value: 0 }
    ]
  }
}
